import { useContext } from "react";

import { Alert, Button, Flex, Skeleton, Text } from "@/storybook-components";

import { ContributionContext } from "../context";

export function Budgeting() {
  const {
    showBudgeting,
    totalFund,
    isLoaded,
    fundLocale,
    hasTotalFunded,
    fundedForLocale,
    undoBudgetingLocale,
    handleBudgeting,
    isBudgetUpdating
  } = useContext(ContributionContext);

  if (!showBudgeting || !totalFund) return null;

  if (!isLoaded)
    return (
      <Skeleton borderRadius="md" h={{ base: "48px", xl: "40px" }} w="full" />
    );

  if (hasTotalFunded)
    return (
      <Alert.Root
        borderRadius="md"
        status="success"
        variant="solid"
        h={{ base: "48px", xl: "40px" }}
      >
        <Alert.Indicator boxSize={{ base: "20px", xl: "16px" }} />
        <Flex flex="1" justifyContent="space-between">
          <Text fontSize={{ base: "md", xl: "md" }}>
            {fundedForLocale} {totalFund}
          </Text>
          <Button
            size="sm"
            variant="link"
            cursor="pointer"
            color="white"
            textDecoration="underline"
            loading={isBudgetUpdating}
            onClick={handleBudgeting}
          >
            {undoBudgetingLocale}
          </Button>
        </Flex>
      </Alert.Root>
    );

  return (
    <Button
      w="full"
      colorPalette="brand"
      onClick={handleBudgeting}
      loading={isBudgetUpdating}
      size={{ base: "lg", xl: "md" }}
    >
      {fundLocale} {totalFund}
    </Button>
  );
}
